import { Can } from "@core/permissions";
import { PortalButton } from "./PortalPrimitives";

// PA-025-E (agent-logs/runs/2026-09-09-spec-211-portal/evidence/
// human-resolution-pa-025-e-duplication.json): el pie del editor
// (Cancelar + Guardar y publicar, condicionado por permiso) era el mismo
// marcado palabra por palabra en BenefitsScreen.tsx y RewardsScreen.tsx.
// Extracción sin cambio de comportamiento ni de valores visuales.
export function EditorFooter({
  onCancel,
  action,
  disabled,
  submitting,
}: {
  onCancel: () => void;
  action: "canCreate" | "canEdit";
  disabled: boolean;
  submitting: boolean;
}) {
  // Revisión en vivo 2026-09-22, puntos #3/#4A: igual que `EditorHeader`, el
  // pie ya no dibuja su `padding` ni su `border-top` — los pone la región
  // `footer` del `Modal`, que además lo deja fijo. "Cancelar" SIGUE siendo
  // `.btn-link`: en el pie de un formulario la baja jerarquía es
  // intencional (lo dice el propio punto #10), no es el caso de una acción
  // de fila indistinguible.
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        gap: 10,
      }}
    >
      <button type="button" className="btn-link" onClick={onCancel}>
        Cancelar
      </button>
      <Can module="content" action={action}>
        <PortalButton type="submit" disabled={disabled}>
          {submitting ? "Guardando…" : "Guardar y publicar"}
        </PortalButton>
      </Can>
    </div>
  );
}
